<i (click)="loadParent(); op.toggle($event)" class="pi pi-info-circle" style="cursor: pointer; margin-left: 2px;color:darkgrey"></i>

<p-overlayPanel #op>
  <ng-template pTemplate>
    <div *ngIf="parent">
      <app-parent-small-detail [parent]="parent"></app-parent-small-detail>
    </div>
  </ng-template>
</p-overlayPanel>
